import Button from '../../../../components/form/elements/button';
import { MouseEventHandler, useState } from 'react';
import { makeButton } from './form-parts';

export default function useCreateFooter(
  handleClick?: MouseEventHandler<HTMLButtonElement>
) {
  const [footer] = useState(() => [
    Button('save'),
    makeButton('cancel', '', '', null, false, handleClick),
  ]);

  return footer;
}
